export function featuredPostSlider() {
    const $slider = $(".featured-post-slider");
    $slider.each(function () {
        let $this = $(this);
        $this.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            fade: true,
            dots: true,
            mobileFirst: true,
            appendDots: $this.next(".featured-post-nav")
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/featuredPostSlider.js